<template>
  <div class="revenue-dashboard">
    
    <!-- Dashboard Widgets (Revenue Summary, etc.) -->
    <div class="dashboard-widgets">
      
      <!-- Total Revenue Widgets -->
      <!-- <h2>Total Revenue</h2> -->
      <div class="widget-row">
        <div class="widget" v-for="(item, index) in widgets.total" :key="'total-' + index">
        <div class="widget-header">
          <h3>{{ item.title }}</h3>
        </div>
        <div class="widget-body">
          <p>₹ {{ item.value }}</p>
        </div>
      </div>
      </div>

      <!-- Paid Revenue Widgets -->
      <!-- <h2>Paid Revenue</h2> -->
      <div class="widget-row">
        <div class="widget" v-for="(item, index) in widgets.paid" :key="'paid-' + index">
        <div class="widget-header">
          <h3>{{ item.title }}</h3>
        </div>
        <div class="widget-body">
          <p>₹ {{ item.value }}</p>
        </div>
      </div>
        </div>

      <!-- Unpaid Revenue Widgets -->
      <!-- <h2>Unpaid Revenue</h2> -->
      <div class="widget-row">
        <div class="widget" v-for="(item, index) in widgets.unpaid" :key="'unpaid-' + index">
        <div class="widget-header">
          <h3>{{ item.title }}</h3>
        </div>
        <div class="widget-body">
          <p>₹ {{ item.value }}</p>
        </div>
        </div>
        </div>

    </div>
<!-- Dashboard Charts -->
    <div class="dashboard-charts">
      <div class="chart">
        <h3>Total Revenue</h3>
        <canvas id="totalRevenueChart"></canvas>
      </div>
      <div class="chart">
        <h3>This Month</h3>
        <canvas id="paidUnpaidThisMonthChart"></canvas>
      </div>
      <div class="chart">
        <h3>This Year</h3>
        <canvas id="paidUnpaidThisYearChart"></canvas>
      </div>
    </div>
    
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';
import { Chart, registerables } from 'chart.js';
import instance from '@/axios';

export default defineComponent({
  name: 'RevenueDashboard',
  setup() {
    const items = ref({
      totalRevenue: 0,
      totalRevenueThisMonth: 0,
      totalRevenueThisYear: 0,
      totalRevenueLastYear: 0,
      paidRevenue: 0,
      paidRevenueThisMonth: 0,
      paidRevenueThisYear: 0,
      paidRevenueLastYear: 0,
      unpaidRevenue: 0,
      unpaidRevenueThisMonth: 0,
      unpaidRevenueThisYear: 0,
      unpaidRevenueLastYear: 0,
    });

    const widgets = computed(() => ({
      total: [
        { title: 'Total Revenue', value: items.value.totalRevenue },
        { title: 'This Month', value: items.value.totalRevenueThisMonth },
        { title: 'This Year', value: items.value.totalRevenueThisYear },
        { title: 'Last Year', value: items.value.totalRevenueLastYear },
      ],
      paid: [
        { title: 'Paid Revenue', value: items.value.paidRevenue },
        { title: 'This Month', value: items.value.paidRevenueThisMonth },
        { title: 'This Year', value: items.value.paidRevenueThisYear },
        { title: 'Last Year', value: items.value.paidRevenueLastYear },
      ],
      unpaid: [
        { title: 'Unpaid Revenue', value: items.value.unpaidRevenue },
        { title: 'This Month', value: items.value.unpaidRevenueThisMonth },
        { title: 'This Year', value: items.value.unpaidRevenueThisYear },
        { title: 'Last Year', value: items.value.unpaidRevenueLastYear },
      ],
    }));

    
    Chart.register(...registerables);

    const renderCharts = () => {
      // Total Revenue Chart
      const totalRevenueCtx = document.getElementById('totalRevenueChart') as HTMLCanvasElement;
      new Chart(totalRevenueCtx, {
      type: 'doughnut',
      data: {
        labels: ['Paid', 'Unpaid'],
        datasets: [
        {
          label: 'Total Revenue',
          data: [
          items.value.paidRevenue,
          items.value.unpaidRevenue,
          ],
          backgroundColor: ['#4CAF50', '#FF5722'],
        },
        ],
      },
      options: {
        responsive: true,
        plugins: {
        legend: {
          display: true,
        },
        },
      },
      });

      // Paid vs Unpaid (This Month) Chart
      const paidUnpaidThisMonthCtx = document.getElementById('paidUnpaidThisMonthChart') as HTMLCanvasElement;
      new Chart(paidUnpaidThisMonthCtx, {
      type: 'doughnut',
      data: {
        labels: ['Paid', 'Unpaid'],
        datasets: [
        {
          data: [
          items.value.paidRevenueThisMonth,
          items.value.unpaidRevenueThisMonth,
          ],
          backgroundColor: ['#2196F3', '#FF5722'],
        },
        ],
      },
      options: {
        responsive: true,
        plugins: {
        legend: {
          display: true,
        },
        },
      },
      });

      // Paid vs Unpaid (This Year) Chart
      const paidUnpaidThisYearCtx = document.getElementById('paidUnpaidThisYearChart') as HTMLCanvasElement;
      new Chart(paidUnpaidThisYearCtx, {
      type: 'doughnut',
      data: {
        labels: ['Paid', 'Unpaid'],
        datasets: [
        {
          data: [
          items.value.paidRevenueThisYear,
          items.value.unpaidRevenueThisYear,
          ],
          backgroundColor: ['#2196F3', '#FF5722'],
        },
        ],
      },
      options: {
        responsive: true,
        plugins: {
        legend: {
          display: true,
        },
        },
      },
      });
    };

    onMounted(() => {
      fetchItems().then(() => {
      renderCharts();
      });
    });

    const fetchItems = async () => {
      const response = await instance.get('/revenue');
      items.value = response.data.Result;
    };

    onMounted(() => {
      fetchItems();
    });

    return { widgets };
  },
});
</script>
<style scoped>
.revenue-dashboard {
  padding: 10px;
  font-family: Arial, sans-serif;
}

.dashboard-widgets {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

h2 {
  margin-bottom: 10px;
  color: #333;
}

.widget-row {
  display: flex;
  gap: 10px; /* Space between widgets */
  flex-wrap: nowrap; /* Prevent wrapping to keep widgets in a single row */
  overflow-x: auto; /* Add horizontal scrolling if widgets exceed container width */
}

.widget {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex: 0 0 calc(25% - 15px); /* Ensure fixed width for 4 widgets per row */
  max-width: calc(25% - 15px); /* Prevent widgets from growing too large */
}

.widget-header h3 {
  margin: 0;
  font-size: 18px;
  color: #555;
}

.widget-body p {
  margin: 5px 0 0;
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.dashboard-charts {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.chart {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex: 1 1 calc(33.333% - 20px); /* Ensure 3 charts per row with responsive layout */
  max-width: calc(33.333% - 20px); /* Prevent charts from growing too large */
  box-sizing: border-box;
}

.chart h3 {
  margin: 0 0 15px;
  font-size: 20px;
  color: #333;
}

.chart canvas {
  width: 100%;
  height: 150px;
}

@media (max-width: 768px) {
  .chart {
    flex: 1 1 calc(50% - 20px); /* Adjust to 2 charts per row on smaller screens */
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 480px) {
  .chart {
    flex: 1 1 100%; /* Adjust to 1 chart per row on very small screens */
    max-width: 100%;
  }
}

</style>

